import type { SEOHeadConfig } from '@sudobility/seo_lib';
import { APP_NAME, APP_DOMAIN } from './constants';
import { LANGUAGE_HREFLANG_MAP } from '@sudobility/svgr_lib';
import { supportedLanguages } from '../i18n';

/**
 * hreflang value per app language code, e.g. `zh -> zh-Hans`.
 *
 * Re-exported from svgr_lib rather than redeclared: the same map drives the
 * sitemaps' `xhtml:link` alternates via `languageHreflangMap` in
 * `seo.config.mjs`. A page whose runtime hreflang disagrees with the sitemap's
 * is a conflicting annotation, and Google may drop the whole language cluster
 * and start choosing its own canonical. `seo.test.ts` asserts the two agree.
 */
export const languageHreflangMap: Readonly<Record<string, string>> = LANGUAGE_HREFLANG_MAP;

export const seoHeadConfig: SEOHeadConfig = {
  appName: APP_NAME,
  baseUrl: `https://${APP_DOMAIN}`,
  defaultOgImage: `https://${APP_DOMAIN}/logo.png`,
  twitterHandle: undefined,
  supportedLanguages: supportedLanguages as unknown as string[],
  languageHreflangMap,
  defaultLanguage: 'en',
  applicationCategory: 'DesignApplication',
  applicationSubCategory: 'Image Converter',
};
